// frontend/src/hooks/usePersistedState.js
import { useState, useEffect } from 'react';

export default function usePersistedState(key, initial) {
    const [value, setValue] = useState(() => {
        try {
            const raw = localStorage.getItem(key);
            return raw === null ? initial : JSON.parse(raw);
        } catch { return initial; }
    });

    useEffect(() => {
        try { localStorage.setItem(key, JSON.stringify(value)); } catch { /* ignore */ }
    }, [key, value]);

    return [value, setValue];
}// JavaScript source code
